/* eslint-disable @typescript-eslint/no-explicit-any */
export const registrations = [
    {
        name: 'Header',
        import: () => import('@stories/Widgets/Global/Header/Header'),
        config: {
            hydrate: 'always',
        },
    },
    {
        name: 'Footer',
        import: () => import('@stories/Widgets/Global/Footer/Footer'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'GlobalStyles',
        import: () => import('@stories/Widgets/Global/GlobalStyles/GlobalStyles'),
        config: {
            hydrate: 'never',
        },
    },
    {
        name: 'ExploreTheForum',
        import: () => import('@stories/Widgets/ExploreTheForum/ExploreTheForum'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'HeroBannerInner',
        import: () => import('@stories/Widgets/HeroBannerInner/HeroBannerInner'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'HeroHomepageBanner',
        import: () => import('@stories/Widgets/HeroHomepageBanner/HeroHomepageBanner'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'HotspotImage',
        import: () => import('@stories/Widgets/HotspotImage/HotspotImage'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'RichText',
        import: () => import('@stories/Widgets/RichText/RichText'),
        config: {
            hydrate: 'never',
        },
    },
    {
        name: 'AccordionList',
        import: () => import('@stories/Widgets/AccordionList/AccordionList'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'CtaCardBlock',
        import: () => import('@stories/Widgets/CtaCardBlock/CtaCardBlock'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'MissionCards',
        import: () => import('@stories/Widgets/MissionCards/MissionCards'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'OverviewCardsAndBenefitCards',
        import: () => import('@stories/Widgets/OverviewCardsAndBenefitCards/OverviewCardsAndBenefitCards'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'KenticoForm',
        import: () => import('@stories/Components/Misc/Forms/KenticoForm/KenticoForm'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'SearchBar',
        import: () => import('@stories/Widgets/SearchBar/SearchBar'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'SearchResults',
        import: () => import('@stories/Widgets/SearchResults/SearchResults'),
        config: {
            hydrate: 'always',
        },
    },
    {
        name: 'VideoImage',
        import: () => import('@stories/Widgets/VideoImage/VideoImage'),
        config: {
            hydrate: 'in-view',
        },
    },
];
